import { SET_ZONE_TYPE,SET_CURRENT_TAB } from "@store/constant";

export const setSubDistrictByHealthBlockId = (key:any,value:any) => {
  return {
    type: 'SET_SUB_DISTRICT',
    payload: {key,value}
  };
};

export const setSubDistrictByDistrict = (key:any,value:any) => {
  return {
    type: 'SET_SUB_DISTRICT_BY_DISTRICT',
    payload: {key,value}
  };
};

export const setBlockByDistrict = (key:any,value:any) => {
  return {
    type: 'SET_BLOCK_BY_DISTRICT',
    payload: {key,value}
  };
};

export const setUlbByState = (key:any,value:any) => {
  return {
    type: 'SET_ULB_BY_STATE',
    payload: {key,value}
  };
};

export const setVillageByHealthBlockId = (key:any,value:any) => {
  return {
    type: 'SET_VILLAGE',
    payload: {key,value}
  };
};

export const setWardByHealthBlockId = (key:any,value:any) => {
  return {
    type: 'SET_WARD',
    payload: {key,value}
  };
};

export const setULBByHealthBlockId = (key:any,value:any) => {
  return {
    type: 'SET_ULB',
    payload: {key,value}
  };
};

export const setBlockByHealthBlockId = (key:any,value:any) => {
  return {
    type: 'SET_BLOCK',
    payload: {key,value}
  };
};
